import React from 'react'
import { AvatarGroup, Avatar } from '@mui/material'
import { Box } from '@material-ui/core'
import { NonprofitOrg } from 'Generated/graphql-types'

type NonprofitOrgAvatarsProps = {
  funderOrgCohort: NonprofitOrg[]
}

export const NonprofitOrgAvatars = ({
  funderOrgCohort,
}: NonprofitOrgAvatarsProps) => {
  const totalOrganizations = funderOrgCohort.length

  const renderSurplus = (surplus: number) => <Box>+{surplus.toString()[0]}</Box>

  const getInitials = (name: string | undefined | null) => {
    if (!name) {
      return ''
    }
    const names = name.split(' ')
    const firstTwoNames = names.slice(0, 2)
    const initials = firstTwoNames.map((orgName) => orgName.charAt(0)).join('')
    return initials.toUpperCase()
  }

  return (
    <AvatarGroup
      renderSurplus={renderSurplus}
      total={totalOrganizations}
      componentsProps={{
        additionalAvatar: {
          sx: { width: '32px', height: '32px', fontSize: '1rem' },
        },
      }}
    >
      {funderOrgCohort.slice(0, 3).map((org) => (
        <Avatar
          key={org.id}
          sx={{ width: '32px', height: '32px', fontSize: '1rem' }}
        >
          {getInitials(org.name)}
        </Avatar>
      ))}
    </AvatarGroup>
  )
}
